module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-01-55c7b65fee23ddad5f6899ed7baf000e.webp";